/**
 * Desktop "Status filters" checkbox options for the Transaction History dropdown.
 * These are display-level groupings, NOT a 1:1 mirror of `WalletTransactionStatus` —
 * `Completed` in particular has no matching raw status: it means "a Buy/Sell row that
 * settled" (Approved/FPXSuccessful AND event is a trade), which is resolved client-side
 * against the fetched rows in WalletComponent.matchesStatusFilter().
 */
export enum StatusFilterOption {
  All = 'All',
  Pending = 'Pending',
  Approved = 'Approved',
  Completed = 'Completed',
  Failed = 'Failed',
}
